      document.addEventListener("DOMContentLoaded", () => {
            gsap.registerPlugin(ScrollTrigger);

            const textElements = document.querySelectorAll(".this-animate-pera p");

            textElements.forEach(textElement => {
                const text = textElement.textContent;
                textElement.innerHTML = text.split("").map(char => `<span>${char}</span>`).join("");

                const chars = textElement.querySelectorAll("span");

                gsap.fromTo(chars,
                    { color: "#014D4E4D" },
                    {
                        color: "#014D4E",
                        scrollTrigger: {
                            trigger: textElement,
                            start: "top 85%",
                            end: "bottom 20%",
                            scrub: true,
                        },
                        stagger: 0.05,
                        duration: 0.5,
                    }
                );
            });
        });
        